/**
 * Common API module
 * This module provides functions to interact with common APIs.
 */
import httpClient from './httpClient';
import { errorMessage, ApiUserInfo } from '@assets/js/util/commonUtil.js';

const sessioncheck = async () => {
    if (window.location.href.indexOf('/sys') > -1) {
        ApiUserInfo().then(userRes => {
            if (!userRes.success || (userRes.success && userRes.data && userRes.data.userInfo == null)) {
                sessionStorage.removeItem('userInfo');
                window.location.href = '/ve';
            }
        });
    }
}

export const getCommonCode = (data) => httpClient.post('/sys/common/code', data);
export const getUserById = (id) => httpClient.get(`/sys/users/${id}`);

export const ApiCall= async (uri, params) => {
    return await httpClient.post(uri, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (res.data && res.data !== '') {
                return { success: true, message: '정상적으로 처리 되었습니다.', data: res.data };
            } else {
                return { success: false, message: '아이디/패스워드를 확인해주세요.', data: res.data };
            }
        })
        .catch(error => {
            console.error('Error deleting data:', error);
            let errMsg = '오류가 발생했습니다.';
            if (error.response.data && error.response.data.reason) {
                console.log(error.response.data.reason);
                errMsg = error.response.data.reason;
            }
            return { success: false, message: errMsg, error: error };
        });
}
export const ApiSearch = async (uri, params) => {
    return await httpClient.post(uri, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (res.data && res.data.result) {
                return { success: true, message: '정상적으로 조회되었습니다.', data: res.data };
            } else {
                sessioncheck();
                return { success: false, message: '오류가 발생했습니다.', data: res.data };
            }
        })
        .catch(error => {
            sessioncheck();
            console.error('Error deleting data:', error);
            let errMsg = '오류가 발생했습니다.';
            if (error.response.data && error.response.data.reason) {
                console.log(error.response.data.reason);
                errMsg = error.response.data.reason;
            }
            return { success: false, message: errMsg, error: error };
        });
}
export const ApiGridSearch = async (uri, params) => {
    return await httpClient.post(uri, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (!res.data || !res.data.result) {
                sessioncheck();
            }
            return res;
        })
        .catch(error => {
            sessioncheck();
            errorMessage(error);
            return error.response;
        });
}
export const removeGrid = async (uri, deleteParams, opt) => {
    let msg = {
        confirm : '삭제 하시겠습니까?',
        message : '정상적으로 삭제되었습니다.',
        error : '오류가 발생했습니다.'
    }
    if (opt && opt.msg && opt.msg.confirm) {
        msg.confirm = opt.msg.confirm;
    }
    if (opt && opt.msg && opt.msg.message) {
        msg.message = opt.msg.message;
    }
    if (opt && opt.msg && opt.msg.error) {
        msg.error = opt.msg.error;
    }

    let isMsgShow = true;
    if (opt && opt.isMsgShow === false) {
        isMsgShow = false;
    }
    
    if (isMsgShow && !window.confirm(msg.confirm)) { return; }

    return await httpClient.post(uri, deleteParams, {
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (res.data && res.data.result) {
                if (isMsgShow) {alert(msg.message);}
                return { success: true, data: res.data };
            } else {
                sessioncheck();
                if (isMsgShow) {alert(msg.error);}
                return { success: false, data: res.data };
            }
        })
        .catch(error => {
            sessioncheck();
            console.error('Error deleting data:', error);
            return { success: false, error: error };
        });
}

export const ApiSave = async (uri, params, opt) => {
    let msg = {
        confirm : '저장 하시겠습니까?',
        message : '정상적으로 저장되었습니다.',
        error : '오류가 발생했습니다.'
    }
    if (opt && opt.msg && opt.msg.confirm) {
        msg.confirm = opt.msg.confirm;
    }
    if (opt && opt.msg && opt.msg.message) {
        msg.message = opt.msg.message;
    }
    if (opt && opt.msg && opt.msg.error) {
        msg.error = opt.msg.error;
    }

    let isMsgShow = true;
    if (opt && opt.isMsgShow === false) {
        isMsgShow = false;
    }

    if (isMsgShow && !window.confirm(msg.confirm)) { return; }

    return await httpClient.post(uri, params, {
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (res.data && res.data.result) {
                if (isMsgShow) {alert(msg.message);}
                return { success: true, data: res.data };
            } else {
                sessioncheck();
                if (isMsgShow) {alert(msg.error);}
                return { success: false, data: res.data };
            }
        })
        .catch(error => {
            sessioncheck();
            console.error('Error save data:', error);
            errorMessage(error);
            return { success: false, error: error };
        });
}

export const ApiSaveForm = async (uri, params, opt) => {
    let msg = {
        confirm : '저장 하시겠습니까?',
        message : '정상적으로 저장되었습니다.',
        error : '오류가 발생했습니다.'
    }
    if (opt && opt.msg && opt.msg.confirm) {
        msg.confirm = opt.msg.confirm;
    }
    if (opt && opt.msg && opt.msg.message) {
        msg.message = opt.msg.message;
    }
    if (opt && opt.msg && opt.msg.error) {
        msg.error = opt.msg.error;
    }

    let isMsgShow = true;
    if (opt && opt.isMsgShow === false) {
        isMsgShow = false;
    }

    if (isMsgShow && !window.confirm(msg.confirm)) { return; }

    // FormData 생성
    const formData = new FormData();

    // params 객체를 FormData에 추가
    Object.keys(params).forEach(key => {
        const value = params[key];

        // File 객체인 경우
        if (value instanceof File) {
            formData.append(key, value);
        }
        // null이나 undefined가 아닌 경우
        else if (value !== null && value !== undefined) {
            formData.append(key, value);
        }
    });

    return await httpClient.post(uri, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true, // 세션 쿠키 유지
        })
        .then(res => {
            if (res.data && res.data.result) {
                if (isMsgShow) {alert(msg.message);}
                return { success: true, data: res.data };
            } else {
                sessioncheck();
                if (isMsgShow) {alert(msg.error);}
                return { success: false, data: res.data };
            }
        })
        .catch(error => {
            sessioncheck();
            console.error('Error save form data:', error);
            errorMessage(error);
            return { success: false, error: error };
        });
}

//file download api
export const ApiDownload = async (uri, params, opt) => {
    let msg = {
        confirm : '다운로드 하시겠습니까?',
        message : '정상적으로 다운로드되었습니다.',
        error : '오류가 발생했습니다.'
    }
    if (opt && opt.msg && opt.msg.confirm) {
        msg.confirm = opt.msg.confirm;
    }
    if (opt && opt.msg && opt.msg.message) {
        msg.message = opt.msg.message;
    }
    if (opt && opt.msg && opt.msg.error) {
        msg.error = opt.msg.error;
    }

    let isMsgShow = true;
    if (opt && opt.isMsgShow === false) {
        isMsgShow = false;
    }

    // 타임아웃 설정 (기본값: 없음, opt.timeout으로 지정 가능)
    let timeout = opt && opt.timeout ? opt.timeout : undefined;

    if (isMsgShow && !window.confirm(msg.confirm)) { return; }

    const config = {
        withCredentials: true, // 세션 쿠키 유지
    };

    // timeout이 설정된 경우에만 추가
    if (timeout !== undefined) {
        config.timeout = timeout;
    }

    return await httpClient.post(uri, params, config)
        .then(res => {
            if (res.data && res.data.result) {
                if (isMsgShow) {alert(msg.message);}
                return { success: true, data: res.data };
            } else {
                sessioncheck();
                if (isMsgShow) {alert(msg.error);}
                return { success: false, data: res.data };
            }
        })
        .catch(error => {
            sessioncheck();
            console.error('Error save data:', error);
            errorMessage(error);
            return { success: false, error: error };
        });
}